import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dialog-update-rol',
  templateUrl: './dialog-update-rol.component.html',
  styleUrls: ['./dialog-update-rol.component.css']
})
export class DialogUpdateRolComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
